<template>
	<div>
		<div class="container">
			
			<div class="row">
				<div class="col-12 px-0">
					<div class="form--v2 px-3 py-4 rounded--11 bg-color--light--2">
						<div class="container">
							<h4 class="text-dark text-align-center font-weight-bold">
									{{ $t("register.identityInfo") }}
								</h4>
							<div class="row justify-content-between mt-3">
								<div class="col-md-5">
									<div>
										<label class="form__label font-size--15 font-w--500">{{
											$t("register.name") + "  :  "
										}}</label>
										<label
											class="form__label text-uppercase font-size--15 font-w--400"
											>{{ "  " + name }}</label
										>
									</div>
								</div>

								<div class="col-md-5">
									<div class="form-group">
										<label
											class="form__label text-uppercase font-size--15 font-w--500"
											>{{ $t("register.lastName") + "  :  " }}</label
										>
										<label
											class="form__label text-uppercase font-size--15 font-w--400"
											>{{ lastName }}</label
										>
									</div>
								</div>
							</div>
							<div class="row justify-content-between">
								<div class="col-md-5">
									<div class="form-group">
										<label
											class="form__label text-uppercase font-size--15 font-w--500"
											>{{ $t("register.melliCode") + "  :  " }}</label
										>
										<label
											class="form__label text-uppercase font-size--15 font-w--400"
											>{{ melliCode }}</label
										>
									</div>
								</div>
								<div class="col-md-5">
									<div class="form-group">
										<label
											class="form__label text-uppercase font-size--15 font-w--500"
											>{{ $t("register.fatherName") + "  :  " }}</label
										>
										<label
											class="form__label text-uppercase font-size--15 font-w--400"
											>{{ fatherName }}</label
										>
									</div>
								</div>
							</div>

							<!-------------- register user Informations ------------->

							<div class="row justify-content-between">
								<div class="col-md-7">
									<div class="form-group">
										<label class="form__label font-size--15 font-w--500">{{
											$t("register.mobileNumber") + "  :  "
										}}</label>
										<label
											class="form__label text-uppercase font-size--15 font-w--400"
											>{{ mobile }}</label
										>
									</div>
								</div>
								<div class="col-md-5">
									<div class="form-group">
										<label
											class="form__label text-uppercase font-size--15 font-w--500"
											>{{ $t("register.phone") + "  :  " }}</label
										>
										<label
											class="form__label text-uppercase font-size--15 font-w--400"
											>{{ phone }}</label
										>
									</div>
								</div>
							</div>
						</div>
						<div class="d-flex flex-column flex-lg-row justify-content-between ">
						<div class="col-md-5">
											
											<div class="form-group ">
												<label
													class="form__label text-uppercase font-size--15 font-w--500"
													>{{ $t("register.birthday") + "  :  " }}</label
												>
												<label
													class="form__label text-uppercase font-size--15 font-w--400"
													>{{ birthDate }}</label
												>
										
											</div>
										</div>
										<div class="col-md-5">
											
											<div class="form-group ">
												<label
													class="form__label text-uppercase font-size--15 font-w--500"
													>{{ $t("register.education") + "  :  " }}</label
												>
												<label v-if="education==0"
													class="form__label text-uppercase font-size--15 font-w--400"
													>{{ $t("register.educations.illiterate")}}</label>
												<label v-if="education==1"
													class="form__label text-uppercase font-size--15 font-w--400"
													>{{ $t("register.educations.elementary")}}</label>
												<label v-if="education==2"
													class="form__label text-uppercase font-size--15 font-w--400"
													>{{ $t("register.educations.sycle")}}</label>
												<label v-if="education==3"
													class="form__label text-uppercase font-size--15 font-w--400"
													>{{ $t("register.educations.diploma")}}</label>
												<label v-if="education==4"
													class="form__label text-uppercase font-size--15 font-w--400"
													>{{ $t("register.educations.skilled")}}</label>
												<label v-if="education==5"
												class="form__label text-uppercase font-size--15 font-w--400"
												>{{ $t("register.educations.bachelor")}}</label>
												<label v-if="education==6"
													class="form__label text-uppercase font-size--15 font-w--400"
													>{{ $t("register.educations.master")}}</label>
												<label v-if="education==7"
													class="form__label text-uppercase font-size--15 font-w--400"
													>{{ $t("register.educations.phd")}}</label>
												<label v-if="education==8"
												class="form__label text-uppercase font-size--15 font-w--400"
												>{{ $t("register.educations.medical")}}</label>
												<label v-if="education==9"
												class="form__label text-uppercase font-size--15 font-w--400"
												>{{ $t("register.educations.clergy")}}</label>
										
											</div>
										</div>
										</div>
										<div class="d-flex flex-lg-row flex-column justify-content-between ">
										<div class="col-md-5">
											
											<div class="form-group ">
												<label
													class="form__label text-uppercase font-size--15 font-w--500"
													>{{ $t("register.gender") + "  :  " }}</label
												>
												<label v-if="gender=='m'"
													class="form__label text-uppercase font-size--15 font-w--400"
													>{{ $t("register.male") }}</label
												>
												<label v-if="gender=='f'"
													class="form__label text-uppercase font-size--15 font-w--400"
													>{{ $t("register.female") }}</label
												>
										
											</div>
										</div>
										<div class="col-md-5">
											
											<div class="form-group ">
												<label
													class="form__label text-uppercase font-size--15 font-w--500"
													>{{ $t("register.maritalStatus") + "  :  " }}</label
												>
												<label v-if="martialStatus==0"
													class="form__label text-uppercase font-size--15 font-w--400"
													>{{ $t("register.single") }}</label
												>
												<label v-if="martialStatus==1"
													class="form__label text-uppercase font-size--15 font-w--400"
													>{{ $t("register.married") }}</label
												>
												<label v-if="martialStatus==2"
													class="form__label text-uppercase font-size--15 font-w--400"
													>{{ $t("register.headOfHousehold") }}</label
												>
										
											</div>
										</div>
										</div>
						<!-------------------------------customer DAta -------------------->
						
						<!-- ----------------------------END Customer DAta------------ -->
						<div
							class="d-flex justify-content-between align-items-center flex-column"
						>
							<hr />
							<div class="container">
								<h4 class="text-dark text-align-center font-weight-bold">
									{{ $t("register.addressInfo") }}
								</h4>
								<br />

								<div class="form-row justify-content-between">
									<div class="col-5">
										<div class="form-group">
											<label
												class="form__label text-uppercase font-size--15 font-w--500"
												>{{ $t("register.province") + "  :  " }}</label
											>
											<label
												class="form__label text-uppercase font-size--15 font-w--400"
												>{{ province }}</label
											>
										</div>
									</div>

									<div class="col-5">
										<div class="form-group">
											<label
												class="form__label text-uppercase font-size--15 font-w--500"
												>{{ $t("register.city") + "  :  " }}</label
											>
											<label
												class="form__label text-uppercase font-size--15 font-w--400"
												>{{ city }}</label
											>
										</div>
									</div>
								</div>
									<div class="form-row justify-content-between">
										<div class="col-5">
										<div class="form-group ">
											<label
												class="form__label text-uppercase font-size--15 font-w--500"
												>{{ $t("register.address") + "  :  " }}</label
											>
											<label
												class="form__label text-uppercase font-size--15 font-w--400"
												>{{ address }}</label
											>
										</div>
										</div>
										<div class="col-5">
										<div class="form-group  ">
												<label
													class="form__label text-uppercase font-size--15 font-w--500"
													>{{ $t("register.homeType") + "  :  " }}</label
												>
												<label v-if="homeType==0"
													class="form__label text-uppercase font-size--15 font-w--400"
													>{{ $t("register.estate.personal") }}</label
												>
												<label v-if="homeType==1"
													class="form__label text-uppercase font-size--15 font-w--400"
													>{{ $t("register.estate.Organizational") }}</label
												>
												<label v-if="homeType==2"
													class="form__label text-uppercase font-size--15 font-w--400"
													>{{ $t("register.estate.rental") }}</label
												>
										
											</div>
											</div>
									</div>
								</div>

								<div class="col-12 pl-0">
									<div class="col-5">
										<div class="form-group ">
											<label
												class="form__label text-uppercase font-size--15 font-w--500 "
												>{{ $t("register.zipCode") + "  :  " }}</label
											>
											<label
												class="form__label text-uppercase font-size--15 font-w--400"
												>{{ zipCode }}</label
											>
										</div>
									</div>
								</div>
							</div>
							<br />
							<br />

							<!-------------------------------JobInfo ------------------------->
							<div class="container mb-4 ">
								<h4 class="font-weight-bold">{{$t("register.jobInfo")}}</h4>
							</div>
							 <div class="d-flex flex-lg-row flex-column justify-content-between">
									<div class="col-md-7">
										<div class="form-group">
											<label class="form__label  font-size--15 font-w--500">{{
												$t("register.jobclass") + "  :  "
											}}</label>
											<label
												v-if="jobClass == '0'"
												class="form__label  font-size--15 font-w--400"
												>{{$t('register.staff')}}</label
											>
											<label
												v-if="jobClass == '1'"
												class="form__label text-uppercase font-size--15 font-w--400"
												>{{$t('register.selfEmployment')}}</label
											>
											<label
												v-if="jobClass == '2'"
												class="form__label text-uppercase font-size--15 font-w--400"
												>{{$t('register.pensioner')}}</label
											>
										</div>
									</div>
									<div class="col-md-5">
										<div class="form-group">
											<label
												class="form__label text-uppercase font-size--15 font-w--500"
												>{{ $t("register.job") + "  :  " }}</label
											>
											<label
												class="form__label text-uppercase font-size--15 font-w--400"
												>{{ job }}</label
											>
										</div>
									</div>
								</div>

								<div class="d-flex flex-lg-row flex-column justify-content-between">
									<div class="col-md-5">
										<div class="form-group">
											<label
												class="form__label text-uppercase font-size--15 font-w--500"
												>{{ $t("register.income") + "  :  " }}</label
											>
											<!-- <label
                        class="form__label text-uppercase font-size--15 font-w--400"
                        >{{ income }}</label
                      > -->
											<vue-numeric
												id="estimate_income"
												separator=","
												v-model="income"
												class="form-control"
												read-only
											></vue-numeric>
										</div>
									</div>
								
									<div class="col-md-5">
												<div class="form-group">
													<label
														class="form__label text-uppercase font-size--15 font-w--500"
														>{{ $t("register.jobAddress") + "  :  " }}</label
													>
													<label
														class="form__label text-uppercase font-size--15 font-w--400"
														>{{ jobAddress }}</label
													>
												</div>
											</div>
								</div>
											<div class="d-flex flex-lg-row flex-column justify-content-between">
											<div class="col-5">
												<div class="form-group">
													<label
														class="form__label text-uppercase font-size--15 font-w--500"
														>{{ $t("register.jobPhoneNumber") + "  :  " }}</label
													>
													<label
														class="form__label text-uppercase font-size--15 font-w--400"
														>{{ jobPhoneNumber}}</label
													>
												</div>
											</div>
											<div class="col-5">
												<div class="form-group">
													<label
														class="form__label text-uppercase font-size--15 font-w--500"
														>{{ $t("register.jobclass") + "  :  " }}</label
													>
													<label v-if="jobClass==0"
														class="form__label text-uppercase font-size--15 font-w--400"
														>{{$t("register.jobClass.govermental") }}</label
													>
													<label v-if="jobClass==1"
														class="form__label text-uppercase font-size--15 font-w--400"
														>{{$t("register.jobClass.libre") }}</label
													>
													<label v-if="jobClass==2"
														class="form__label text-uppercase font-size--15 font-w--400"
														>{{$t("register.jobClass.Pensioner") }}}</label
													>
													<label v-if="jobClass==3"
														class="form__label text-uppercase font-size--15 font-w--400"
														>{{ $t("register.jobClass.private") }}</label
													>
													<label v-if="jobClass==4"
														class="form__label text-uppercase font-size--15 font-w--400"
														>{{ $t("register.jobClass.army") }}</label
													>
													<label v-if="jobClass==5"
														class="form__label text-uppercase font-size--15 font-w--400"
														>{{ $t("register.jobClass.Retired") }}</label
													>
												</div>
											</div>
											</div>
											<div class="col-5">
												<div class="form-group">
													<label
														class="form__label text-uppercase font-size--15 font-w--500"
														>{{ $t("supplier.status") + "  :  " }}</label
													>
													<label v-if="customerStatus=='00'"
														class="form__label text-uppercase font-size--15 font-w--400"
														>{{$t("customer.watingForDocs") }}</label
													>
													<label v-if="customerStatus=='0'"
														class="form__label text-uppercase font-size--15 font-w--400"
														>{{$t("customer.inprogressing") }}</label
													>
													<label v-if="customerStatus==1"
														class="form__label text-uppercase font-size--15 font-w--400"
														>{{$t("customer.confirmed") }}}</label
													>
													<label v-if="customerStatus==2"
														class="form__label text-uppercase font-size--15 font-w--400"
														>{{ $t("customer.rejected") }}</label
													>
													<label v-if="customerStatus==3"
														class="form__label text-uppercase font-size--15 font-w--400"
														>{{ $t("customer.conditionalConfirm") }}</label
													>
													<label v-if="customerStatus==4"
														class="form__label text-uppercase font-size--15 font-w--400"
														>{{ $t("customer.customerCanceled") }}</label
													>
													<label v-if="customerStatus==5"
														class="form__label text-uppercase font-size--15 font-w--400"
														>{{ $t("customer.defectiveDocuments") }}</label
													>
													<label v-if="customerStatus==6"
														class="form__label text-uppercase font-size--15 font-w--400"
														>{{ $t("customer.creditRatingExpiration") }}</label
													>
												</div>
											</div>
								
							<!-------------------------------status -------------------------->
							<div class="container mt-4">
								<h4 class=" font-weight-bold text-dark text-align-center">وضعیت</h4>
								<br />

								<div class="form-row justify-content-between">
									<div class="col-6">
										<div class="form-group">
											<label
												class="form__label text-uppercase font-size--15 font-w--500"
												>{{ "سطح تسهیلات" + "  :  " }}</label
											>
											<label
												v-if="level == '1'"
												class="form__label text-uppercase font-size--15 font-w--400"
											>
												{{ $t("setLevel.level1") }}
											</label>
											<label
												v-if="level == '2'"
												class="form__label text-uppercase font-size--15 font-w--400"
											>
												{{ $t("setLevel.level2") }}</label
											>
											<label
												v-if="level == '3'"
												class="form__label text-uppercase font-size--15 font-w--400"
											>
												{{ $t("setLevel.level3") }}
											</label>
										</div>
									</div>
									<div class="col-5">
										<div class="form-group">
											<label
												class="form__label text-uppercase font-size--15 font-w--500"
												>{{ "وضعیت کاربر" + "  :  " }}</label
											>
											<label
												v-if="status == 0"
												class="form__label text-uppercase font-size--15 font-w--400"
												><span class="badge badge-secondary">{{
													$t("customer.inprogressing")
												}}</span></label
											>
											<label
												v-if="status == 1"
												class="form__label text-uppercase font-size--15 font-w--400"
												><span class="badge badge-success">{{
													$t("customer.confirmed")
												}}</span></label
											>
											<label
												v-if="status == 2"
												class="form__label text-uppercase font-size--15 font-w--400"
												><span class="badge badge-danger">{{
													$t("customer.rejected")
												}}</span></label
											>
											<label
												v-if="status == 3"
												class="form__label text-uppercase font-size--15 font-w--400"
												><span class="badge badge-warning">{{
													$t("customer.conditionalConfirm")
												}}</span></label
											>
											<label
												v-if="status == 4"
												class="form__label text-uppercase font-size--15 font-w--400"
												><span class="badge badge-danger">{{
													$t("customer.customerCanceled")
												}}</span></label
											>
										</div>
									</div>
								</div>

								<div class="form-row justify-content-start">
									<div class="col-5">
										<div class="form-group">
											<label
												class="form__label text-uppercase font-size--15 font-w--500"
												>{{ "توضیحات" + "  :  " }}</label
											>
											<div class="credit_rank">
												<label
													class="form__label text-uppercase font-size--13 font-w--400 mr-1 ml-1 mt-1"
													>{{ credit_rank }}</label
												>
											</div>
										</div>
									</div>
								</div>
							</div>
					
							<!-----------------------------End status ------------------------>

							<!-- <button
								class="btn btn-bg--primary btn-size--md btn-hover--3d"
								type="submit"
								@click.prevent="edit"
							>
								<span class="btn__text">ویرایش اطلاعات </span>
							</button> -->
						
						<br />
						<br />
						<hr />
						<div class="d-flex  flex-column" >
							<router-link
						
								:to="this.id + '/docs'"
								class="btn btn-bg--dark btn-size--sm btn-hover--3d"
							>
								<span class="font-size--13 font-w--300">بارگذاری مدارک</span>
							</router-link>
							</div>
						</div>
						</div>
						<!-- end of form -->
					</div>
					<!-- end of from area -->

					<!-- end of col -->
				</div>
				<!-- end of row -->

				<!-- end of container -->
				
			</div>
		
		<!-- =========== End of Body ============ -->
	
</template>

<script>
import VueNumeric from "vue-numeric";
import * as moment from 'jalali-moment';
export default {
	mounted() {
		this.getSuppliersCustomer();
		// this.checkEdit();
		

	},
	watch:
	{
		'$route.name':
		{
			handler:function ()
			{
				this.getSuppliersCustomer()
			}
		}
	},
	props: ["id"],
	data() {
		return {
			alert: false,
			errors: [],

			//-----------------------
			name: "",
			lastName: "",
			fatherName: "",
			melliCode: "",
			phoneNumberDescription:'',
			birthDate:'',
			gender:'',
			martialStatus:'',
			education:'',
			jobClass: "",
			job: "",
			homeType:"",
			mobile: "",
			phone: "",
			province: "",
			city: "",
			address: "",
			zipCode: "",
			income: "",
			level: "",
			status: "",
			credit_rank: "",
			contract_status: "",
			customerStatus:"",
			job_workplace: "",
			jobPhoneNumber: "",
			job_class: "",
			job_status: "",
			jobAddress: "",
			estimate_income: "",
			mobile_number:"",
			melli_code:""
		};
	},

	
	computed:{
		// editable() {
		// 	console.log(this.contract_status) 
		// 	console.log("contract_status", this.contract_status!='9') 
		// 	return this.contract_status!=='9'
		// }
	},
	methods: {
		getSuppliersCustomer() {
			
			let load = this.$loading.show();
			this.$store
				.dispatch("getSuppliersCustomer", this.id)
				.then((response) => {
					console.log(response);
					this.name = response.body.first_name;
					this.lastName = response.body.last_name;
					this.melliCode = response.body.melli_code;
					this.fatherName = response.body.father_name;
					this.mobile = response.body.mobile_number;
					this.phone = response.body.phone_number;
					this.homeType = response.body.home_type
					this.phoneNumberDescription = response.body.phone_number_description
					if(response.body.birth_date)
					{
						this.birthDate = this.convertDate(response.body.birth_date) 
					}

					this.gender = response.body.gender
					this.martialStatus = response.body.marital_status
					this.education=response.body.education
					this.province = response.body.province;
					this.city = response.body.city;
					this.address = response.body.address;
					this.income = response.body.estimate_income;
					(this.jobClass = response.body.job_class),
						(this.job = response.body.job),
						(this.zipCode = response.body.postal_code);
					this.level = response.body.level;
					this.status = response.body.status;
					this.credit_rank = response.body.credit_rank;
					this.contract_status = response.body.contract_status;
					
					this.jobClass = response.body.job_class
					this.jobAddress=response.body.job_address
					this.jobPhoneNumber=response.body.job_phone_number
					this.jobClass=response.body.job_class
					this.customerStatus=response.body.status
					load.hide();
				})	
				.catch((err) => {
					console.log(err);
					load.hide();
				});
		},
		convertDate(date)
		{
			
			
			var newDate=date.replace(/-/g, '/')
			return moment(newDate, 'YYYY/MM/DD').locale('fa').format('YYYY/MM/DD')
			
		}

		// checkEdit() {
		// 	if (this.contract_status != "9") {
		// 		this.$tabs.close("/supplier/customers/" + this.id + "/edit");
		// 		this.$tabs.close("/supplier/customers/" + this.id + "/set-level");
		// 	}
		// },
		// edit() {
		// 	this.$swal({
		// 		theme: "Bootstrap 4",
		// 		icon: "error",
		// 		title: "هشدار",
		// 		text:
		// 			"در صورت ویرایش اطلاعات، وضعیت کاربری مشتری به <<درحال بررسی>> تغییر خواهد کرد و دوباره باید منتظر تایید اطلاعات باشید",
		// 		showCancelButton: true,
		// 		confirmButtonText: "تایید",
		// 		cancelButtonText: "انصراف",
		// 		confirmButtonColor: "#3085d6",
		// 		cancelButtonColor: "#d33",
		// 	}).then((result) => {
		// 		if (result.value) {
		// 			this.$router.push("edit");
		// 		}
		// 	});
		// },
	},

	components: {
		VueNumeric,
	},
};
</script>

<style>
.vpd-icon-btn {
	display: flex;
	width: 1%;
	cursor: pointer;
	padding: 0 10px;
}
.credit_rank {
	background-color: white;
}
</style>
